module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8bdIk"))).then(() => parcelRequire('3a9aZ'));